<script>
import { isEmpty } from 'lodash'
import ExtraForm from '@src/forms/Extra'
import Request from '@src/mixins/request'

export default {
  $_veeValidate: { validator: 'new' },

  mixins: [Request],

  props: {
    propertyId: {
      type: [String, Number],
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: new ExtraForm(),
      extraUnits: [],
      color: 'gold',
      schema: ExtraForm.validator(),
      deleteDialog: false,
    }
  },

  computed: {
    text() {
      if (isEmpty(this.item)) {
        return { heading: 'New Extra', submit: 'Add' }
      }

      return { heading: 'Edit Extra', submit: 'Update' }
    },
    fileUploadOpts() {
      return {
        url: '/api' + this.endpoint.extra.addImage,
        addRemoveLinks: true,
        paramName: 'image',
      }
    },
    images() {
      return isEmpty(this.item) ? [] : this.item.images
    },
  },

  mounted() {
    this.fetchDropdown()
    this.form = new ExtraForm(this.item)
  },

  methods: {
    async fetchDropdown() {
      this.extraUnits = await this.fetchData({
        url: this.endpoint.dropdown.extraUnits,
      })
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (isEmpty(this.item)) {
            this.addItem()
          } else {
            this.updateItem()
          }
        }
      })
    },
    addItem() {
      this.updateData({
        url: this.endpoint.extra.add,
        data: {
          propertyId: this.propertyId,
          data: this.form,
        },
      }).then(() => {
        this.backToList()
      })
    },
    updateItem() {
      this.updateData({
        url: this.endpoint.extra.update,
        data: {
          id: this.item.id,
          propertyId: this.propertyId,
          update: this.form,
        },
      }).then(() => {
        this.backToList()
      })
    },
    async deleteImage(index) {
      await this.updateData({
        url: this.endpoint.extra.delImage,
        data: {
          id: this.item.id,
          index,
        },
      })
      this.item.images.splice(index, 1)
      this.deleteDialog = false
    },
    backToList() {
      this.$emit('event', { currentView: 'ExtraList' })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseView :title="text.heading" :color="color">
      <VLayout row wrap>
        <!-- Basic Info -->
        <VFlex class="mb-4" xs12>
          <div class="title mb-2">Basic Info</div>

          <BaseControlInput label="Name">
            <VTextField
              v-model="form.name"
              v-validate="schema.name"
              data-vv-name="name"
              label="Name"
              :error-messages="errors.collect('name')"
              :color="color"
            />
          </BaseControlInput>

          <BaseControlInput label="Description">
            <VTextarea
              v-model="form.description"
              v-validate="schema.description"
              data-vv-name="description"
              label="Description"
              :error-messages="errors.collect('description')"
              :color="color"
            />
          </BaseControlInput>

          <BaseControlInput label="Price">
            <VTextField
              v-model="form.price"
              v-validate="schema.price"
              data-vv-name="price"
              label="Price"
              prefix="USD"
              :error-messages="errors.collect('price')"
              :color="color"
            />
          </BaseControlInput>

          <BaseControlInput label="Price unit">
            <VAutocomplete
              v-model="form.priceUnit"
              label="Price unit"
              :color="color"
              :items="extraUnits"
              item-text="name"
              item-value="code"
            />
          </BaseControlInput>
        </VFlex>
        <!-- End of Basic Info -->

        <!-- Photos -->
        <VFlex class="mb-4" xs12>
          <div class="title mb-2">Photos</div>

          <BaseGallery
            uploader
            :color="color"
            :images="images"
            :uploader-options="fileUploadOpts"
            :delete-dialog.sync="deleteDialog"
            :additional-params="{ id: item.id }"
            @delete-img="deleteImage"
          />
        </VFlex>
        <!-- End of Photos -->
      </VLayout>

      <template slot="card-actions-right">
        <VBtn
          depressed
          :disabled="loading"
          @click="$emit('event', { currentView: 'ExtraList' })"
        >
          Cancel
        </VBtn>

        <VBtn
          :color="color"
          :loading="loading"
          :disabled="!!errors.count()"
          type="submit"
          depressed
          :dark="!errors.count()"
        >
          {{ text.submit }}
        </VBtn>
      </template>
    </BaseView>
  </VForm>
</template>
